
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Chess Tournament</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Tournament Report of GH Raisoni Memorial
                <span>Bhandara District Chess Tournament 2023</span>
            </h2>
        </div>

        <div class="row">
            <div class="col-md-8">

                <div class="fide-chess-text">
                    <p> GH Raisoni Memorial Bhandara District level chess
                        tournament concluded at Lakhni.</p>
                    <p>A district-level chess tournament was organized at Lakhni
                        on 9th April 2023 in association with
                        Raisoni Group, GH Raisoni Sports and Cultural
                        Foundation, Kalpana Prakash Welfare Foundation
                        (KPWF), and Classic and Rapid Chess Circle Association
                        Bhandara. This competition was held in
                        open groups. Dr. Nachiket Paturkar came first in the
                        open group followed by Yug Kawle second and
                        Krish Dharamsare third and from the girl's category Riya
                        Dharamsare came first, Raha Bagde
                        second and Mithali Tekam got the third prize. In this
                        competition, the youngest Adhira Karbe,
                        and the eldest Nilesh Bhoskar were also felicitated with
                        medals. Also, all the players were
                        honored with certificates and medals.</p>
                    <p>Total 8 Trophies and 30 Medals were Sponsored by Raisoni
                        Group, Chess Borad and Clocks were
                        provided by Kalpana Prakash Welfare Foundation.</p>

                    <p> Prizes were distributed at the hands of Lakhni Panchayat
                        Samiti Group Development Officer
                        Shekhar Jadhav Sir, Kalpana Prakash Welfare Foundation
                        and Chess Association Nagpur (CAN)
                        Secretary Bhushan Shriwas Sir, Sarvabhaum Yuva Manch
                        Youth President Deepak Janbandhu, OBC Seva
                        Sangh President Umeshji Singhanjude, Ashwini Bhivagde
                        was the coordinator of the program.
                        National Arbiter Sagar Sakhre worked very hard to ensure
                        that this competition was conducted
                        properly and he was assisted by Kshitij Girhepunje.
                        Those who are selected through this
                        tournament will represent Bhandara district in the state
                        level chess tournament to be held now.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-bg-23.jpg"
                        alt />

                </div>
            </div>
        </div>
        <iframe
            src="https://drive.google.com/file/d/1DoA0yokOxUunOL1UkDj--n5eRJGv5xxC/preview"
            width="100%"
            height="600px" frameborder="0"></iframe>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 ">
            <div class="gall-ery">
                <div class="col">
                    <div class="row">
                        <div class="col-md-7">
                            <div
                                class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul
                            class="list-unstyled lightgallery row row-cols-1 row-cols-md-5">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-bhandara2.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-bhandara2.jpg">
                                <a href="Javascript:void(0);">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-bhandara2.jpg"
                                        alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-bhandara1.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-bhandara1.jpg">
                                <a href="Javascript:void(0);">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-bhandara1.jpg"
                                        alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-bhandara3.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-bhandara3.jpg">
                                <a href="Javascript:void(0);">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-bhandara3.jpg"
                                        alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-bhandara4.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-bhandara4.jpg">
                                <a href="Javascript:void(0);">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess-bhandara4.jpg"
                                        alt="GHRSCF" title="GHRSCF"
                                        class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>

                </div>

            </div>

        </div>
    </div>

</section>
